<template>
  <div class="d-flex flex-column align-items-center">
    <div class="app-container col-12 col-sm-8 col-md-6 col-lg-5 col-xl-3 vue-container">
      <LoadingOverlay v-if="this.isLoading"/>
      <router-view/>
    </div>
  </div>
</template>

<script>
import LoadingOverlay from "@/views/components/LoadingOverlay";
import {mapState} from "vuex";

export default {
  components: {LoadingOverlay},
  computed: {
    ...mapState(['isLoading']),
    methods: {
      setFavicon() {
        const faviconLink = document.getElementById('favicon');
        faviconLink.href = './img/icons/android-chrome-192x192.png';
        let manifest = {
          name: "App name",
          icons: [{
            src: `./img/icons/android-chrome-192x192.png`,
            sizes: "192x192",
            type: "image/png"
          }, {
            src: `./img/icons/android-chrome-512x512.png`,
            sizes: "512x512",
            type: "image/png"
          }, {
            src: `./img/icons/android-chrome-maskable-192x192.png`,
            sizes: "192x192",
            type: "image/png"
          }, {
            src: `./img/icons/android-chrome-maskable-512x512.png`,
            sizes: "512x512",
            type: "image/png"
          }]
        };
        let content = encodeURIComponent(JSON.stringify(manifest));
        let url = "data:application/manifest+json," + content;
        let element = document.createElement('link');
        element.setAttribute('rel', 'manifest');
        element.setAttribute('href', url);
        document.querySelector('head').appendChild(element);
      },
    },
    async beforeMount() {
      this.setFavicon()
    },
  },
}
</script>

<style>

@import url(https://db.onlinewebfonts.com/c/4baee4a2550da10078fd0d6dd9440bc1?family=MTN+Brighter+Sans+Regular);

.vue-container {
  position: relative;
  background: linear-gradient(180deg, #ffcc08 0%, #f3b705 50%, #e8a102 100%);
  background-size: cover;
  min-height: 100vh;
  overflow-x: hidden;
  border: .5px solid #636363;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  font-family: "MTN Brighter Sans Regular", system-ui, sans-serif;
}
</style>
